import React, { useEffect, useState } from "react";
import { FaSearch, FaCrosshairs } from "react-icons/fa";
import { Building2 } from "lucide-react";
import useCities from "../../services/Navbar/common/LocationPopup";
import { useLocationContext } from "../../context/LocationContext";

/* 🔥 ADD THIS */
import { usePopupLock } from "../../context/PopupLockContext";

export default function LocationPopup({ isOpen, onClose }) {
  const {
    cities,
    suggestions,
    setSuggestions,
    getAllCities,
    searchCities,
  } = useCities();

  const { setCityManually, fetchLocation } = useLocationContext();

  /* 🔥 NEW */
  const { openLock, closeLock } = usePopupLock();

  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (isOpen) {
      getAllCities();

      /* 🔥 LOCK OPEN */
      openLock("location");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  // ✅ SELECT CITY
  const handleSelectCity = (city) => {
    setCityManually(city);

    const name = city?.cityName || city?.name;

    setSearch(name);
    setShowDropdown(false);
    setSuggestions([]);

    /* 🔥 UNLOCK */
    closeLock("location");

    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white w-[90%] max-w-3xl rounded-2xl p-6 relative">

        <button
          onClick={() => {
            closeLock("location");   /* 🔥 IMPORTANT */
            onClose();
          }}
          className="absolute right-4 top-3 text-gray-500 text-xl"
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-4">Select Your City</h2>

        <div className="flex gap-2 mb-5">

          <div className="relative flex-1">
            <div className="flex items-center border px-3 py-2 rounded-lg">
              <FaSearch className="mr-2 text-gray-400" />

              <input
                value={search}
                onChange={(e) => {
                  const val = e.target.value;
                  setSearch(val);

                  if (val.trim()) {
                    setShowDropdown(true);
                    searchCities(val);
                  } else {
                    setShowDropdown(false);
                    setSuggestions([]);
                  }
                }}
                className="w-full outline-none"
                placeholder="Search city"
              />
            </div>

            {showDropdown && suggestions.length > 0 && (
              <div className="absolute w-full bg-white shadow mt-1 rounded-lg max-h-60 overflow-auto">
                {suggestions.map((city, i) => {
                  const name = city?.cityName || city?.name;

                  return (
                    <div
                      key={i}
                      onClick={() => handleSelectCity(city)}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {name}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <button
            onClick={() => {
              localStorage.removeItem("selectedCity");
              fetchLocation();
              closeLock("location");   /* 🔥 IMPORTANT */
              onClose();
            }}
            className="bg-red-500 text-white px-3 rounded-lg flex items-center gap-1"
          >
            <FaCrosshairs /> Detect Location
          </button>
        </div>

        <div className="grid grid-cols-3 gap-3 mb-4">
          {cities.slice(0, 6).map((city, i) => {
            const name = city?.cityName || city?.name;

            return (
              <div
                key={i}
                onClick={() => handleSelectCity(city)}
                className="p-3 border rounded-lg text-center cursor-pointer"
              >
                <Building2 className="mx-auto mb-1" />
                {name}
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-2 gap-2">
          {cities.map((city, i) => {
            const name = city?.cityName || city?.name;

          
          })}
        </div>
      </div>
    </div>
  );
}